/* ***************************************************************************************
Creating the base of milsymbol
*************************************************************************************** */
import { ms } from "./ms.js";

import Symbol from "./ms/symbol.js";
ms.Symbol = Symbol;

/* ***************************************************************************************
Export ms to the world
*************************************************************************************** */
export { ms };
